// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer","footer__PrivacyArea":"footer__PrivacyArea","footer__externalSites":"footer__externalSites"};